/** @format */

import {AnalyticType, StatState} from 'types';

import {STATS_PROVIDERS} from '../const';
import {CompanyFromQuery, ProjectTableInterface} from '../types';
import {getTokenStatus} from './getTokenStatus';

/**
 * Если в рекламной системе больше одной системы, то вернет больше одного объекта
 * Использовать этот метод необходимо внутри flatMap вместо map
 * @param company
 */

const mapCompany = (company: CompanyFromQuery): ProjectTableInterface[] => {
  const tokens = [...company.tokens];

  const adTokens = tokens.filter(token => !STATS_PROVIDERS.includes(token.provider));

  const statTokens = tokens
    .filter(token => STATS_PROVIDERS.includes(token.provider))
    .map(d => d.provider) as AnalyticType[];

  const exclusions = company.sensorExclusions.map(sensor => sensor.sensorName);

  const {
    sensorGroups: {red, gray, yellow},
  } = company;
  const groupedSensorNames = red.concat(gray).concat(yellow);
  const isGroupingSet = groupedSensorNames.length > 0;

  const triggered = company.lastChecks.reduce((acc, cur) => {
    // Не считать исключенные сенсоры

    const isExcluded = exclusions.includes(cur.sensor.name);
    if (isExcluded) {
      return acc;
    }

    if (isGroupingSet) {
      // Фильтровать срабатывания по этим сенсорам
      const isGrouped = groupedSensorNames.includes(cur.sensor.name);
      if (isGrouped) {
        return acc + cur.found;
      }
      return acc;
    }

    // Группировка не задана: выводить сумму срабатываний по всем сенсорам.
    return acc + cur.found;
  }, 0);

  if (adTokens.length > 1) {
    return adTokens.map(token => ({
      id: `${company.id}-${token.id}`,
      companyID: company.id,
      title: company.name,
      tokenStatus: getTokenStatus(company.stats, token),
      adSystem: token.provider,
      analytics: statTokens,
      triggered,
      tokens,
    }));
  }

  if (adTokens.length === 1) {
    return [
      {
        id: company.id,
        companyID: company.id,
        title: company.name,
        tokenStatus: getTokenStatus(company.stats, adTokens[0]),
        adSystem: adTokens[0].provider,
        analytics: statTokens,
        triggered,
        tokens,
      },
    ];
  }

  const isNew: StatState = statTokens.length > 0 ? 'READY' : 'NEW';

  return [
    {
      id: company.id,
      companyID: company.id,
      title: company.name,
      tokenStatus: isNew,
      adSystem: null,
      analytics: statTokens,
      triggered,
      tokens,
    },
  ];
};

export {mapCompany};
